import { useState } from "react";
import { useParams } from 'react-router-dom';
import projects from '../utilities/project-data';
import { Carousel } from 'react-bootstrap';
import { CodeBlock, dracula } from "react-code-blocks";
import React from "react";
import * as SimpleIcons from "react-icons/si";

function SingleProject() {
    const { projectID } = useParams();
    
    const [projectData, setProjectData] = useState(projects); // initialize projects data

    // single project data is equal to the filtered value from the projectData matched by the projectID from useParams
    const [singleProjectData, setSingleProjectData] = useState( projectData.filter(data => data.id === projectID) ); //initialize single Project data

    //console.log(singleProjectData);

    return (
        <section className="single-project-page">
            <section className="project-container">
                {
                    //Map through the projects array and display all the appropriate data
                    singleProjectData.map((singleProject) => {
                        return <article className="single-project" key={singleProject.id}>
                    <Carousel fade>
                        <Carousel.Item interval={1000000}>
                            <div className="slide-content">
                                <img
                                className="d-block w-100" src={`${singleProject.slide_show.slide_1}`}
                                alt="First slide"
                                />
                            </div>
                        </Carousel.Item>
                        <Carousel.Item interval={1000000}>
                            <div className="slide-content">
                                <img
                                className="d-block w-100" src={`${singleProject.slide_show.slide_2}`}
                                alt="Second slide"
                                />
                            </div>
                        </Carousel.Item>
                        <Carousel.Item interval={1000000}>
                            <div className="slide-content">
                                <img
                                className="d-block w-100" src={`${singleProject.slide_show.slide_3}`}
                                alt="Third slide"
                                />
                            </div>
                        </Carousel.Item>
                    </Carousel>
                            <div className="title-and-link-container">
                                <h2 className="project-title">{singleProject.title}</h2>
                                <a className="external-project-link grow" href={singleProject.external_link}>{singleProject.category === "Design" ? "View Prototype" : "View Website"}</a>
                            </div>
                            <div className="tech-stack">
                                <h3>Tech Stack:</h3> {singleProject.techStack.map((item, i) => React.createElement(SimpleIcons[`${item}`]))}
                            </div>

                            <div className="description">
                                <h2>Project Overview</h2>
                                <p>{singleProject.long_description}</p>
                            </div>
                            {/* Varying content area -> Design process vs Code Snippets */}
                            {singleProject.code_block !== undefined &&
                            <div className="code-snippet">
                                <div className="code">
                                    <h2>Code Block</h2>
                                    <h3>Code Snippet</h3>
                                    <CodeBlock text={singleProject.code_block.text} 
                                    language={singleProject.code_block.language} 
                                    theme={dracula}/>
                                </div>
                                <div className="explanation">
                                    <h3>Explanation</h3>
                                    <p>{singleProject.code_block.explanation}</p>
                                </div>
                            </div>
                            }

                            {singleProject.design_process !== undefined &&
                            <div className="design-process">
                                <h2>Design Process</h2>
                                <h3>Phase 1</h3>
                                <p>{singleProject.design_process[0]}</p>
                                <h3>Phase 2</h3>
                                <p>{singleProject.design_process[1]}</p>
                                <h3>Phase 3</h3>
                                <p>{singleProject.design_process[2]}</p>
                            </div>
                            }

                            {/* Varying content area -> Moving Forward vs Final Thoughts */}
                            {   singleProject.moving_forward !== undefined &&
                                <div className="closing-statements">
                                    <h2>Moving Forward</h2>
                                    <p>{singleProject.moving_forward}</p>
                                </div>
                            }
                            {   singleProject.conclusion !== undefined &&
                                <div className="closing-statements">
                                    <h2>Final Thoughts</h2>
                                    <p>{singleProject.conclusion}</p>
                                </div>
                            }

                        </article>
                    })
                }
            </section>
        </section>
    )
}

export default SingleProject;
